import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchHarvestProcess(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/production/query_by_producers/show_producer/${organization_id}/fetch_harvest_process/${harvest_process_id}`
    );
  },

  fetchProducer(
    organization_id,
    harvest_process_id,
    producer_type,
    producer_id
  ) {
    return RequesterV1.get(
      `organization/production/query_by_producers/show_producer/${organization_id}/fetch_producer/${harvest_process_id}/${producer_type}/${producer_id}`
    );
  },

  fetchSummary(
    organization_id,
    harvest_process_id,
    producer_type,
    producer_id
  ) {
    return RequesterV1.get(
      `organization/production/query_by_producers/show_producer/${organization_id}/fetch_summary/${harvest_process_id}/${producer_type}/${producer_id}`
    );
  },

  fetchHarvestsMonthly(
    organization_id,
    harvest_process_id,
    producer_type,
    producer_id
  ) {
    return RequesterV1.get(
      `organization/production/query_by_producers/show_producer/${organization_id}/fetch_harvests_monthly/${harvest_process_id}/${producer_type}/${producer_id}`
    );
  },

  fetchHarvestsWeekly(
    organization_id,
    harvest_process_id,
    producer_type,
    producer_id
  ) {
    return RequesterV1.get(
      `organization/production/query_by_producers/show_producer/${organization_id}/fetch_harvests_weekly/${harvest_process_id}/${producer_type}/${producer_id}`
    );
  },

  fetchTotalsMonthly(
    organization_id,
    harvest_process_id,
    producer_type,
    producer_id
  ) {
    return RequesterV1.get(
      `organization/production/query_by_producers/show_producer/${organization_id}/fetch_totals_monthly/${harvest_process_id}/${producer_type}/${producer_id}`
    );
  },

  fetchTotalsWeekly(
    organization_id,
    harvest_process_id,
    producer_type,
    producer_id
  ) {
    return RequesterV1.get(
      `organization/production/query_by_producers/show_producer/${organization_id}/fetch_totals_weekly/${harvest_process_id}/${producer_type}/${producer_id}`
    );
  },

  fetchCropSizes(
    organization_id,
    harvest_process_id,
    producer_type,
    producer_id
  ) {
    return RequesterV1.get(
      `organization/production/query_by_producers/show_producer/${organization_id}/fetch_crop_sizes/${harvest_process_id}/${producer_type}/${producer_id}`
    );
  },

  fetchHarvestedBatchesTotal(
    organization_id,
    harvest_process_id,
    producer_type,
    producer_id
  ) {
    return RequesterV1.get(
      `organization/production/query_by_producers/show_producer/${organization_id}/fetch_harvested_batches_total/${harvest_process_id}/${producer_type}/${producer_id}`
    );
  },

  fetchHarvestedBatches(
    organization_id,
    harvest_process_id,
    producer_type,
    producer_id,
    current_page,
    rows_per_page
  ) {
    return RequesterV1.get(
      `organization/production/query_by_producers/show_producer/${organization_id}/fetch_harvested_batches/${harvest_process_id}/${producer_type}/${producer_id}/${current_page}/${rows_per_page}`
    );
  },

  fetchHarvestedBatch(
    organization_id,
    harvest_process_id,
    harvested_batch_id
  ) {
    return RequesterV1.get(
      `organization/production/query_by_producers/show_producer/${organization_id}/fetch_harvested_batch/${harvest_process_id}/${harvested_batch_id}`
    );
  }
};
